<template>
  <div class="flex md12 adresse-infos">
    <div class="row">
      <div class="flex md11">
        <va-input
          :disabled="isDisabled"
          v-model="adresseInfosMod.adresse"
          placeholder="Adresse inconnue"
          label="Adresse"
        />
      </div>
      <div class="flex md1">
        <va-button
          small
          ref="toclipboard"
          flat
          color="primary"
          icon="fa fa-copy"
          @click="adresse2clipboard"
        />
      </div>
      <div class="flex md12">
        <va-input
          :disabled="isDisabled"
          v-model="adresseInfosMod.complement"
          placeholder="Complement d'adresse"
          label="Adresse suite"
        />
      </div>
      <div class="flex md2">
        <va-input
          :disabled="isDisabled"
          v-model="adresseInfosMod.code_postal"
          placeholder="Code Postal"
          label="Code Postal"
        />
      </div>
      <div class="flex md7">
        <va-input
          :disabled="isDisabled"
          v-model="adresseInfosMod.ville"
          placeholder="Ville"
          label="Ville"
        />
      </div>
      <div class="flex md3">
        <va-input
          :disabled="isDisabled"
          v-model="adresseInfosMod.cedex"
          placeholder="Cedex"
          label="Cedex"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep, isEqual } from "lodash";

export default {
  props: ["adresseInfos", "isDisabled"],

  data() {
    return {
      infosUpdated: false,
      adresseInfosMod: {
        id: null,
        code_postal: null,
        ville: null,
        adresse: null,
        complement: null,
        cedex: null
      }
    };
  },
  mounted() {},
  methods: {
    adresse2clipboard(e) {
      this.$emit("copy2clipboard", this.clipboardAdresse);

      this.$nextTick(() => {
        e.target.blur();
      });
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000
      });
    }
  },
  computed: {
    clipboardAdresse: function() {
      let adresse = this.adresseInfosMod.adresse
        ? this.adresseInfosMod.adresse + "\r\n"
        : "";
      let complement = this.adresseInfosMod.complement
        ? this.adresseInfosMod.complement + "\r\n"
        : "";

      let ville = this.adresseInfosMod.code_postal
        ? this.adresseInfosMod.code_postal
        : "";

      if (this.adresseInfosMod.ville) {
        ville = ville + " " + this.adresseInfosMod.ville;
      }

      if (this.adresseInfosMod.cedex) {
        ville = ville + " " + this.adresseInfosMod.cedex;
      }

      ville = ville;

      let results = adresse + complement + ville;

      return results;
    },
    isFormValid: function() {
      if (this.validSurname || this.validName) {
        return false;
      }
      return true;
    },
    validName: function() {
      return false;
    },
    validSurname: function() {
      return false;
    }
  },
  watch: {
    adresseInfosMod: {
      deep: true,
      handler() {
        if (!isEqual(this.adresseInfosMod, this.adresseInfos)) {
          this.$emit("infosChanged", true);
          this.infosUpdated = true;
        } else {
          this.$emit("infosChanged", false);
          this.infosUpdated = false;
        }
      }
    },
    adresseInfos: {
      deep: true,
      immediate: true,
      handler() {
        this.adresseInfosMod = cloneDeep(this.adresseInfos);
      }
    }
  }
};
</script>

<style lang="scss">
.adresse-infos > * > .flex {
  padding-left: 0.25rem;
}
</style>
